function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  "data-name": "Trazado 256",
  d: "M3.485 6.981a.91.91 0 01-.642-.266L.266 4.139A.908.908 0 111.55 2.855l1.935 1.934L8.008.266A.908.908 0 119.292 1.55L4.126 6.716a.905.905 0 01-.641.265z",
  fill: "#ffc06a"
});

var SvgBespokenCheckNoCircleIcon = function SvgBespokenCheckNoCircleIcon(props) {
  return React.createElement("svg", _extends({
    "data-name": "Grupo 392",
    width: 9.559,
    height: 6.981
  }, props), _ref);
};

export default SvgBespokenCheckNoCircleIcon;